<div class="displayFlex">
  <!-- Header -->
  <nz-row class="w-65">
    <nz-col nzSpan="15" class="header-title">
      <div>
        <h4 class="text-left color-gray">
          {{ trackReport.trackVSMaximoSummary }}
        </h4>
        <h6 class="text-left subtitle">{{ trackReport.allData }}</h6>
      </div>
    </nz-col>
    <nz-col nzSpan="9">
      <div>
        <table class="w-auto">
          <tr>
            <td>
              <b>{{ trackReport.contractor }}:</b>
            </td>
            <td class="text-left">{{ reportData.contractor }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ trackReport.workDate }}:</b>
            </td>
            <td class="text-left">{{ reportData.date }}</td>
          </tr>
        </table>
      </div>
    </nz-col>
  </nz-row>

  <!-- Data -->
  <nz-row class="w-65 bgcolor-gray">
    @if (!trackMXSummaryResponse) {
      <div class="item-center mt-5 w-100">
        <mat-progress-spinner
          color="primary"
          mode="indeterminate"
          diameter="50"
        ></mat-progress-spinner>
      </div>
    }
    @if (trackMXSummaryResponse) {
      <table class="m-15 table table-bordered">
        <tr>
          <th class="text-left">{{ trackReport.labor }}:</th>
          <th class="track-color">{{ trackReport.track }}</th>
          <th class="maximo-color">{{ trackReport.maximo }}</th>
          <th class="variance-color">{{ trackReport.variance }}</th>
        </tr>
        <!-- st hours -->
        <tr>
          <td class="text-red text-left">
            <b>{{ trackReport.stHours }}</b>
          </td>
          <td class="track-color">
            {{ trackMXSummaryResponse.trackStHrs | decimalRound }}
          </td>
          <td class="maximo-color">
            {{ trackMXSummaryResponse.maxSthrs | decimalRound }}
          </td>
          <td class="variance-color">
            {{ trackMXSummaryResponse.varStHrs | decimalRound }}
          </td>
        </tr>
        <!-- ot hours -->
        <tr>
          <td class="text-red text-left">
            <b>{{ trackReport.otHours }}</b>
          </td>
          <td class="track-color">
            {{ trackMXSummaryResponse.trackOtHrs | decimalRound }}
          </td>
          <td class="maximo-color">
            {{ trackMXSummaryResponse.maxOthrs | decimalRound }}
          </td>
          <td class="variance-color">
            {{ trackMXSummaryResponse.varOtHrs | decimalRound }}
          </td>
        </tr>
        <!-- dt hours -->
        <tr>
          <td class="text-red text-left">
            <b>{{ trackReport.dtHours }}</b>
          </td>
          <td class="track-color">
            {{ trackMXSummaryResponse.trackDtHrs | decimalRound }}
          </td>
          <td class="maximo-color">
            {{ trackMXSummaryResponse.maxDthrs | decimalRound }}
          </td>
          <td class="variance-color">
            {{ trackMXSummaryResponse.varDtHrs | decimalRound }}
          </td>
        </tr>
        <!-- totals -->
        <tr class="mt-2 mb-2">
          <td rowspan="2" class="text-red d-block text-left">
            <b>{{ trackReport.totals }}</b>
          </td>
          <td class="track-color">
            <table id="inner-table">
              <tr>
                <td class="text-red col-md-6">
                  <b>{{ trackReport.hours }}</b>
                </td>
                <td class="text-red col-md-6">
                  <b>{{ trackReport.cost }}</b>
                </td>
              </tr>
              <tr>
                <td class="col-md-6">
                  {{ trackMXSummaryResponse.trackTotalHrs | decimalRound }}
                </td>
                <td class="col-md-6">
                  ${{ trackMXSummaryResponse.trackLabCost | decimalRound }}
                </td>
              </tr>
            </table>
          </td>
          <td class="maximo-color">
            <table id="inner-table">
              <tr>
                <td class="text-red col-md-6">
                  <b>{{ trackReport.hours }}</b>
                </td>
                <td class="text-red col-md-6">
                  <b>{{ trackReport.cost }}</b>
                </td>
              </tr>
              <tr>
                <td class="col-md-6">
                  {{ trackMXSummaryResponse.maxTotalHrs | decimalRound }}
                </td>
                <td class="col-md-6">
                  ${{ trackMXSummaryResponse.maxLabCost | decimalRound }}
                </td>
              </tr>
            </table>
          </td>
          <td class="variance-color">
            <table id="inner-table">
              <tr>
                <td class="text-red col-md-6">
                  <b>{{ trackReport.hours }}</b>
                </td>
                <td class="text-red col-md-6">
                  <b>{{ trackReport.cost }}</b>
                </td>
              </tr>
              <tr>
                <td class="col-md-6">
                  {{ trackMXSummaryResponse.varTotalHrs | decimalRound }}
                </td>
                <td class="col-md-6">
                  (${{ trackMXSummaryResponse.varTotalCost | decimalRound }})
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- per dim -->
        <tr>
          <td class="d-block text-left">
            <b>{{ trackReport.perDim }}:</b>
          </td>
          <td class="track-color">
            <table id="inner-table">
              <tr>
                <td class="col-md-6">{{ trackReport.count }}</td>
                <td class="col-md-6">{{ trackReport.cost }}</td>
              </tr>
              <tr>
                <td class="col-md-6">
                  {{ trackMXSummaryResponse.TrackPdCnt | decimalRound }}
                </td>
                <td class="col-md-6">
                  ${{ trackMXSummaryResponse.TrackPdCost | decimalRound }}
                </td>
              </tr>
            </table>
          </td>
          <td class="maximo-color">
            <table id="inner-table">
              <tr>
                <td class="col-md-6">{{ trackReport.count }}</td>
                <td class="col-md-6">{{ trackReport.cost }}</td>
              </tr>
              <tr>
                <td class="col-md-6">
                  {{ trackMXSummaryResponse.MaxPdCnt | decimalRound }}
                </td>
                <td class="col-md-6">
                  ${{ trackMXSummaryResponse.MaxPdCost | decimalRound }}
                </td>
              </tr>
            </table>
          </td>
          <td class="variance-color">
            <table id="inner-table">
              <tr>
                <td class="col-md-6">{{ trackReport.count }}</td>
                <td class="col-md-6">{{ trackReport.cost }}</td>
              </tr>
              <tr>
                <td class="col-md-6">
                  {{ trackMXSummaryResponse.varPerDiemCount | decimalRound }}
                </td>
                <td class="col-md-6">
                  ${{ trackMXSummaryResponse.varPerDiemCost | decimalRound }}
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- equipment -->
        <tr>
          <td class="text-left">
            <b>{{ trackReport.equipment }}:</b>
          </td>
          <td class="track-color">
            <table id="inner-table">
              <tr>
                <td class="text-red">
                  <b>{{ trackReport.hours }}</b>
                </td>
              </tr>
              <tr>
                <td>
                  {{ trackMXSummaryResponse.TrackEquipHrs | decimalRound }}
                </td>
              </tr>
            </table>
          </td>
          <td class="maximo-color">
            <table id="inner-table">
              <tr>
                <td class="text-red">
                  <b>{{ trackReport.hours }}</b>
                </td>
              </tr>
              <tr>
                <td>
                  {{ trackMXSummaryResponse.MaxEquipHrs | decimalRound }}
                </td>
              </tr>
            </table>
          </td>
          <td class="variance-color">
            <table id="inner-table">
              <tr>
                <td class="text-red">
                  <b>{{ trackReport.hours }}</b>
                </td>
              </tr>
              <tr>
                <td>
                  {{ trackMXSummaryResponse.varPerEquipHrs | decimalRound }}
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- grand totals -->
        <tr>
          <td class="d-block text-left">
            <b>{{ trackReport.grandTotals }}:</b>
          </td>
          <td>
            <table id="inner-table">
              <tr>
                <td class="text-red col-md-6">
                  <b>{{ trackReport.hours }}</b>
                </td>
                <td class="text-red col-md-6">
                  <b>{{ trackReport.cost }}</b>
                </td>
              </tr>
              <tr>
                <td class="col-md-6">
                  {{ trackMXSummaryResponse.grandTotalTrackHrs | decimalRound }}
                </td>
                <td class="col-md-6">
                  ${{ trackMXSummaryResponse.grandTotalTrackCost | decimalRound }}
                </td>
              </tr>
            </table>
          </td>
          <td>
            <table id="inner-table">
              <tr>
                <td class="text-red col-md-6">
                  <b>{{ trackReport.hours }}</b>
                </td>
                <td class="text-red col-md-6">
                  <b>{{ trackReport.cost }}</b>
                </td>
              </tr>
              <tr>
                <td class="col-md-6">
                  {{ trackMXSummaryResponse.grandTotalMaxHrs | decimalRound }}
                </td>
                <td class="col-md-6">
                  ${{ trackMXSummaryResponse.grandTotalMaxCost | decimalRound }}
                </td>
              </tr>
            </table>
          </td>
          <td>
            <table id="inner-table">
              <tr>
                <td class="text-red col-md-6">
                  <b>{{ trackReport.hours }}</b>
                </td>
                <td class="text-red col-md-6">
                  <b>{{ trackReport.cost }}</b>
                </td>
              </tr>
              <tr>
                <td class="col-md-6">
                  {{ trackMXSummaryResponse.grandTotalVarHrs | decimalRound }}
                </td>
                <td class="col-md-6">
                  (${{ trackMXSummaryResponse.grandTotalVarCost | decimalRound }})
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    }
  </nz-row>
</div>
